/* eslint max-len: 0 */
import React, { SVGProps } from "react";

const HomeWifi = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width="32px"
      height="32px"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon--home-wifi"
      {...props}
    >
      <path
        d="M15.3399 3.98849C15.8129 3.69942 16.4079 3.69942 16.8809 3.98849L27.2244 10.3095C27.6636 10.5779 27.9315 11.0556 27.9315 11.5704V26.9058H30.7391C30.8359 26.4284 30.8868 25.9342 30.8868 25.4282V11.5704C30.8868 10.0261 30.0831 8.59305 28.7654 7.78781L18.422 1.46679C17.0029 0.59961 15.2179 0.59961 13.7989 1.46679L3.45536 7.78781C2.13765 8.59305 1.33398 10.0261 1.33398 11.5704V25.4282C1.33398 25.9342 1.38486 26.4284 1.48178 26.9058H4.28927V11.5704C4.28927 11.0556 4.55716 10.5779 4.99639 10.3095L15.3399 3.98849Z"
        fill={props.fill || "currentColor"}
      />
      <path
        d="M29.4091 29.8633H22.0204C22.0183 29.8633 22.016 29.8633 22.0139 29.8633H10.9446H10.9381H2.81055C4.15846 31.6578 6.3045 32.8186 8.72163 32.8186H23.498C25.9152 32.8186 28.0612 31.6578 29.4091 29.8633Z"
        fill={props.fill || "currentColor"}
      />
      <path
        d="M6.12891 13.9696C8.36606 11.91 11.3529 10.6523 14.6335 10.6523H17.5888C20.8694 10.6523 23.8562 11.91 26.0934 13.9696L24.3599 16.4004C22.6235 14.6743 20.2307 13.6076 17.5888 13.6076H14.6335C11.9916 13.6076 9.59885 14.6743 7.86233 16.4004L6.12891 13.9696Z"
        fill={props.fill || "currentColor"}
      />
      <path
        d="M22.4292 19.1073C21.0746 17.5482 19.0774 16.5625 16.8499 16.5625H15.3722C13.1448 16.5625 11.1475 17.5482 9.79297 19.1073L11.5934 21.6319C12.3734 20.3635 13.774 19.5178 15.3722 19.5178H16.8499C18.4481 19.5178 19.8488 20.3635 20.6288 21.6319L22.4292 19.1073Z"
        fill={props.fill || "currentColor"}
      />
      <path
        d="M13.8945 24.6891C13.8945 23.465 14.8868 22.4727 16.111 22.4727C17.3351 22.4727 18.3275 23.465 18.3275 24.6891C18.3275 25.9132 17.3351 26.9056 16.111 26.9056C14.8868 26.9056 13.8945 25.9132 13.8945 24.6891Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

HomeWifi.displayName = "HomeWifi";

export default HomeWifi;
